import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9780d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "part-name" }
const _hoisted_4 = {
  key: 0,
  class: "content-main"
}

import {ref} from 'vue'
import {useRouter} from "vue-router";
import MainLive from './MainLive.vue'
import MainRecorded from './MainRecorded.vue'
import {CoursePlanPartVO} from "@/apis/course";
import {ArrowLeftBold, ArrowRightBold} from "@element-plus/icons";
import usePartConvert from "@/composables/usePartConvert";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainContent',
  props: {
    part: {}
  },
  emits: ['nav-trigger'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const router = useRouter()

const typeMap = {
  RECORDED: MainRecorded,
  LIVE: MainLive,
  PROJECT: MainRecorded,
  EXAM: MainRecorded,
}

const showNav = ref<boolean>(true)
const emits = __emit
const {convertPartType} = usePartConvert()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass(["nav-trigger-btn", !showNav.value && 'reverse']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('nav-trigger', showNav.value = !showNav.value)))
      }, [
        _createVNode(_unref(ArrowLeftBold))
      ], 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(convertPartType)(_ctx.part) + _ctx.part.partName), 1),
      _createElementVNode("span", {
        class: "exit-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).go(-1)))
      }, [
        _createTextVNode("退出学习 "),
        _createVNode(_unref(ArrowRightBold), { class: "icon" })
      ])
    ]),
    (_ctx.part)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(typeMap[_ctx.part.type]), {
            part: _ctx.part,
            key: _ctx.part.id
          }, null, 8, ["part"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})